import { useCallback } from "react";
import GraphBuilderService from "../../../../../../services/graph-builder/GraphBuilderService";
import { IGraph } from "../../../../../../components/graph-builder/types/GraphTypes";

export const useExportToGremlin = () => {
  return useCallback(async (scheme: IGraph) => {
    return GraphBuilderService.exportToQuery(scheme);
  }, []);
};
